import * as Yup from "yup";
import { REGEX } from "../../utils/constants";
/**
 * @description declaration form schema for client validations
 */
export const locSchema = Yup.object().shape({
  email: Yup.string()
    .email("Invalid email address")
    .required("Email address field is required"),
  name: Yup.string()
    .matches(REGEX.NAME, "This field only accepts alphabets!")
    .required("This field is required"),
  address: Yup.string().required("This field is required"),
  phone: Yup.string()
    .trim()
    .matches(
      /^(\([0-9]{3}\) |[0-9]{3}-)?[0-9]{3}-[0-9]{4}$/,
      "Invalid Phone Number"
    )
    .required("This field is required"),
});

/**
 * @description params intilaization
 */

export const locInit = {
  email: "",
  phone: "",
  name: "",
  address: "",
};
